import React, { useState, useEffect } from "react";
import BASE_URL from "components/BaseUrl/apiConfig";
import Navbar from "components/Navbars/AuthNavbar";
import Footer from "components/Footers/Footer";
import BlockUiOverlay from "components/Expense/BlockUiOverlay";
import { AddPayment } from "./CommonModel";

const PaymentTracking = () => {
  const [payments, setPayment] = useState([]);
  const [currency, setCurrency] = useState("");
  const [loading, setLoading] = useState(false);
  //get userid form loca storage
  const storedUserData = localStorage.getItem("userData");
  let userId = "";
  let groupId = "";
  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    userId = userData.userId;
    groupId = userData.groupId;
  }

  const fetchPayment = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${BASE_URL}/api/PaymentsTracking/GetAllPayments?userId=${userId}`
      );
      const data = await response.json();
      setPayment(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  //Call function on any change on this page
  useEffect(() => {
    fetchPayment();
  }, []); // Fetch items when component mounts

  useEffect(() => {
    const fetchCurrencyData = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/Users/GetCurrencyByUserId?groupId=${groupId}`
        );
        const data = await response.json();
        // Assuming the API response has a property called 'currency'
        setCurrency(data.currency);
      } catch (error) {
        console.error("Error fetching currency data:", error);
      } finally {
      }
    };

    fetchCurrencyData();
  }, []);
  return (
    <>
      <Navbar />
      <div className="cust-div" style={{ minHeight: "550px" }}>
        <BlockUiOverlay visible={loading} />
        <div className="container mx-auto  p-4">
          <div className="flex justify-between items-center mb-4 flex-wrap">
            <h1 className="text-2xl  font-bold">
              Payment Tracking({currency}){" "}
            </h1>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full min-w-full ">
              <thead>
                <tr className="border-b bg-lightBlue-500 text-white ">
                  <th className="cell py-2 px-4 font-bold text-left">
                    Payment Date
                  </th>
                  <th className="cell py-2 px-4 font-bold text-left">
                    Paid Amount
                  </th>
                  <th className="cell py-2 px-4 font-bold text-left">
                    Item Name
                  </th>
                </tr>
              </thead>
              <tbody>
                {payments && payments.length > 0 ? (
                  payments.map((payment) => (
                    <tr
                      key={payment.paymentID}
                      className="hover:bg-gray-100 border-b"
                    >
                      <td className="cell py-1 px-4 text-left">
                        {new Date(payment.paymentDate).toLocaleDateString(
                          "en-GB",
                          { day: "2-digit", month: "2-digit", year: "numeric" }
                        ) === "01/01/1"
                          ? null
                          : new Date(payment.paymentDate).toLocaleDateString(
                              "en-GB",
                              {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                              }
                            )}
                      </td>
                      <td className="cell py-1 px-4 text-left">
                        {payment.paymentAmount}
                      </td>
                      <td className="cell py-1 px-4 text-left">
                        {payment.itemName}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="8"
                      className="text-center text-lg text-gray-900 mt-4"
                    >
                      No data found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Add/Edit Modal */}
      {/* <AddPayment isOpen={isOpen} onClose={closeModal} selectItem={selectItem} fetchPayment={fetchPayment} /> */}
      <Footer />
    </>
  );
};

export default PaymentTracking;
